import React, { useEffect, useState, useReducer, useRef } from "react";
import { api, handleErrors } from "src/Basic/ApiFetch";
import { useTranslation } from 'react-i18next';
import { ServerConfig, GetHistory } from "src/Basic/BasicData";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import {
  showGlobalMessageBox,
  getGlobalServerConfig
} from "src/Route/RootMiddleware";

const LoginAnnouncement = () => {
  // 所有公告資料
  const allAnnData = useRef([]);
  // 公告顯示元素
  const [dataJsx, setDataJsx] = useState(null);
  // 展開狀態
  const [isExpended, setIsExpended] = useState(false)
  const { t } = useTranslation();

  useEffect(() => {
    readDisplayAnnoucement();
  }, []);

  /**
   * 讀取display公告
   */
  const readDisplayAnnoucement = async () => {
    let response = await api
      .Get(getGlobalServerConfig().backEndUrl.get() + "Announcement/Display")
      .then(handleErrors)
      .catch((error) => {
        showGlobalMessageBox("發生伺服器端錯誤，請聯繫管理員。", () => {
          GetHistory().push("/");
        });
      });
    if (!response) return;

    if (!response.ok) {
      setDataJsx([{ COMMENT: "公告載入失敗" }]);
      return;
    }

    // 公告所有資料
    const allData = await response.json();

    if (!allData || allData.length === 0) {
      setDataJsx([]);
      return;
    }

    // 預設顯示前三項資料
    const firstThreeItems = allData.slice(0, 3);
    setDataJsx(annList(firstThreeItems));
    allAnnData.current = allData;
  };

  /**
   * 展開公告
   * @param {*} e 
   */
  const expand = () => {
    setDataJsx(annList(allAnnData.current))
    setIsExpended(true);
  }

  /**
   * 清單Jsx
   * @param {Array} 公告資料
   * @returns {JSX}
   */
  const annList = (data) => {
    return data.map(item => {
      return (
        <div className="login_left_list">
          <div className="login_left_list_headline">{item.COMMENT}</div>
          <div className="login_left_list_txt">{item.EFFECTIVE_TWDATE}</div>
        </div>
      )
    })
  }

  return (
    <div className="login_content_left_box_width">
      {dataJsx && dataJsx.length > 0 ?
        (
          <div>
            <div className="login_left_headline">{t('moea_ic.logInPage.announcement')}</div>
            {dataJsx}
            {!isExpended && <div className="login_left_list_btn" onClick={() => { expand() }}>{t('moea_ic.logInPage.view')}</div>}
          </div>
        )
        :
        dataJsx != null && dataJsx.length === 0 ?
          (
            <div className="login_left_list_headline">{t('moea_ic.logInPage.noAnnouncement')}</div>
          )
          :
          (
            t('moea_ic.logInPage.loadAnnouncement')
          )
      }
    </div >
  );
};

export default LoginAnnouncement;